import React, { useContext } from 'react'
import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material'
import { PIGGY_BANKS_MULTIPLIER, applyDiscount, applyFee } from '@playback-rewards/shared-libraries'

//components
import PriceText from 'components/giftCards/PriceText'
import DiscountTag from '../DiscountTag'
//contexts
import AuthContext from 'context/AuthContext'
//styles
import './index.css'
//types
import { AuthContextType, GiftCardProps } from 'types'
//utils
import { formatNumber } from 'utils/utils'

const GiftCard = ({ giftCard, denomination, discount }: GiftCardProps) => {
  const { user } = useContext(AuthContext) as AuthContextType

  const piggyBanksValue = applyFee(
    PIGGY_BANKS_MULTIPLIER(denomination),
    giftCard.fee,
    giftCard.minFeeValue && PIGGY_BANKS_MULTIPLIER(giftCard.minFeeValue)
  )

  let discountedPiggyBanksValue
  if (discount) {
    discountedPiggyBanksValue = applyDiscount(piggyBanksValue, discount)
  }

  return (
    <div className="giftCardListCardInner">
      <Card className="giftCardListCard" sx={styles.card} data-denomination={denomination}>
        <Box sx={styles.cardContainer}>
          <CardMedia component="img" sx={styles.cardMedia} src={giftCard.image} />
          {discount && (
            <Box sx={styles.discountOverlay}>
              <DiscountTag discount={discount} />
            </Box>
          )}
        </Box>
        <CardContent sx={styles.cardContent}>
          <Typography variant="h3" sx={styles.currency}>
            ${denomination} USD
          </Typography>
          <div className="giftCardListCardCurrency">
            <PriceText
              userBalance={user?.piggyBanks}
              giftCardValue={piggyBanksValue}
              value={formatNumber(piggyBanksValue)}
              {...(discount && { discountedGiftCardValue: discountedPiggyBanksValue })}
              {...(discount && { discountedValue: formatNumber(discountedPiggyBanksValue) })}
              isPig={true}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

const styles = {
  card: {
    width: '216px',
    borderRadius: '12px',
    transition: 'none',
    boxShadow: '0px 12px 16px -4px #0014311F',
    cursor: 'pointer',
  },
  cardContainer: {
    position: 'relative',
  },
  discountOverlay: {
    position: 'absolute',
    bottom: 5,
    left: 3,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'start',
  },
  cardMedia: {
    height: '136px',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 12px',
    backgroundColor: '#fff',
    '&:last-child': {
      paddingBottom: '8px',
    },
    height: '80px',
  },
  currency: {
    color: '#18181B',
  },
}

export default GiftCard
